<template>
  <su-page>
    <el-row class="mt30" slot="content" style="margin-left: -20px">
      <el-form v-if="token" ref="formData" :model="form" :rules="rules" label-width="120px">
        <div class="signUp">
          <div>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-select style="width: 100%;" v-model="form.sex" placeholder="请选择">
                <el-option class="option" label="男" value="1"></el-option>
                <el-option class="option" label="女" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="民族" prop="nation">
              <el-input v-model="form.nation" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="图片" prop="picture">
              <div class="uploadDescription1 cl666">
                尺寸: 2.5*3.5cm,图片不能超过500k,此照片作为证书照片,请上传符合标准的一寸免冠照片,报名后不能修改。
              </div>
              <el-row class="flex">
                <div class="align-center">
                  <el-upload
                      class="uploader"
                      :action="baseApi"
                      :show-file-list="false"
                      :on-success="pictureSuccess"
                      :before-upload="beforeAvatarUpload">
                    <img v-if="form.picture" :src="form.picture" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  上传图片
                </div>
                <div class="align-center">
                  <img v-if="picture" :src="picture" class="avatar mlr10">
                  示例图片
                </div>
                <div class="uploadDescription cl666">
                  尺寸: 2.5*3.5cm,图片不能超过500k,此照片作为证书照片,请上传符合标准的一寸免冠照片,报名后不能修改。
                </div>
              </el-row>
            </el-form-item>
          </div>
          <el-form-item label="证件类型" prop="cert_type">
            <el-select style="width: 100%;" v-model="form.cert_type" placeholder="请选择">
              <el-option class="option" label="身份证" value="身份证"></el-option>
              <el-option class="option" label="护照" value="护照"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="cert_no">
            <el-input
                v-model="form.cert_no"
                :placeholder="!form.cert_type?'请先选择证件类型':'请输入证件号码'"
                @blur="certNoBlur(form.cert_no)"
                :disabled="!form.cert_type"/>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
                style="width: 100%;"
                v-model="form.birthday"
                type="date"
                format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input type="number" v-model="form.age" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="考试报名" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio-button label="0">初考</el-radio-button>
            <el-radio-button label="1">补考</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div class="signUp">
          <el-form-item :label="form.type == '1'? '初考考点':'所在考点'" prop="address_id">
            <el-select style="width: 100%;" v-model="form.address_id" placeholder="请选择" @change="addressChange">
              <el-option
                  class="option"
                  :key="index"
                  :label="item.firm"
                  :value="item.id"
                  v-for="(item,index) in addressList"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考试时间" prop="exam_time">
            <el-date-picker
                disabled
                style="width: 100%;"
                v-model="form.exam_time"
                type="date"
                format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <div v-if="form.type === '1'">
            <el-form-item label="补考科目" prop="exam_subject">
              <el-select style="width: 100%;" multiple v-model="form.exam_subject" placeholder="请选择">
                <el-option
                    class="option"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-for="item in subjectList"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="最高学历" prop="education">
            <el-select style="width: 100%;" v-model="form.education" placeholder="请选择">
              <el-option
                  class="option"
                  :key="index"
                  :label="item"
                  :value="item"
                  v-for="(item,index) in educationList"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="毕业/就读院校" prop="school">
            <el-input v-model="form.school" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="专业" prop="personal">
            <el-input v-model="form.personal" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="普通话等级" prop="mandarin">
            <el-select style="width: 100%;" v-model="form.mandarin" placeholder="请选择">
              <el-option
                  class="option"
                  :key="index"
                  :label="item"
                  :value="item"
                  v-for="(item,index) in pthList"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="国际中文相关证书" prop="is_teacher" label-width="135px" v-if="form.type == 0">
            <el-select style="width: 100%;" v-model="form.is_teacher" placeholder="请选择">
              <el-option
                  class="option"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                  v-for="(item,index) in is_teacherList"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所学外语及程度" prop="foreign" label-width="130px">
            <el-select style="width: 100%;" v-model="form.foreign" placeholder="请选择">
              <el-option
                  class="option"
                  :key="index"
                  :label="item"
                  :value="item"
                  v-for="(item,index) in foreignList"
              ></el-option>
            </el-select>
            <!--<el-input v-model="form.languageLevel" placeholder="请输入"></el-input>-->
          </el-form-item>
          <el-form-item label="缴费方式" prop="pay_type">
            <el-select style="width: 100%;" v-model="form.pay_type" placeholder="请选择">
              <el-option class="option" label="微信" value="0"></el-option>
              <el-option class="option" label="支付宝" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通讯地址" prop="address">
            <el-input v-model="form.address" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="Emall" prop="email">
            <el-input v-model="form.email" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="微信号" prop="wx_account">
            <el-input v-model="form.wx_account" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="mobile">
            <el-input type="number" v-model="form.mobile" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="form.remark" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <div class="signUp">
          <el-form-item
              label="国际中文相关证书图片"
              prop="teacher_cert"
              label-width="165px"
              v-if="form.is_teacher && form.type == 0">
            <el-upload
                class="uploader"
                :action="baseApi"
                :show-file-list="false"
                :on-success="isTeacherSuccess"
                :before-upload="beforeAvatarUpload">
              <img v-if="form.teacher_cert" :src="form.teacher_cert" class="uploaderImg"/>
              <i v-else class="el-icon-plus uploaderIcon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
              label="普通话证书图片"
              prop="man_cert"
              label-width="130px"
              v-if="form.mandarin && form.mandarin != '二级乙等或以上均无'">
            <el-upload
                class="uploader"
                :action="baseApi"
                :show-file-list="false"
                :on-success="hmanCertSuccess"
                :before-upload="beforeAvatarUpload">
              <img v-if="form.man_cert" :src="form.man_cert" class="uploaderImg"/>
              <i v-else class="el-icon-plus uploaderIcon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
              label="外语证书图片"
              prop="foreign_cert"
              label-width="130px"
              v-if="form.foreign && form.foreign != '以上均无'">
            <el-upload
                class="uploader"
                :action="baseApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
              <img v-if="form.foreign_cert" :src="form.foreign_cert" class="uploaderImg"/>
              <i v-else class="el-icon-plus uploaderIcon"></i>
            </el-upload>
          </el-form-item>
        </div>
        <div class="mt20 cl000 f14 mlr20">
          <div class="align-center mb10">
            报名费总计：考试费用 （{{ total.toFixed() }}元） = {{ total.toFixed(2) }}元
          </div>
          <div class="align-center">注：{{ tip }}</div>
          <div class="flex al-cn ju-cn mtb20">
            <el-button type="primary" @click="submitForm('formData')">提交</el-button>
            <el-button @click="resetForm('formData')">重置</el-button>
          </div>
          <div class="flex al-cn ju-cn war-pe f12">
            <el-checkbox v-model="checked">
              <div class="cl333">报名信息一经提交不能修改，我已阅读并同意</div>
            </el-checkbox>
            <div class="cl1189FB pointer" @click.stop="dialogVisible = true">《考试报名协议》</div>
          </div>
        </div>
      </el-form>
      <el-empty v-else description="请登录后操作"></el-empty>
      <el-dialog title="考试报名协议" :visible.sync="dialogVisible" :width="dialogWidth">
        <div v-html="agreementContent"></div>
      </el-dialog>
      <!-- 微信支付弹框 -->
      <el-dialog
          :visible.sync="buy_code"
          title="微信支付"
          @close="buy_close"
          :close-on-click-modal="false"
          width="350px"
          center>
        <div class="mb20 align-center">请用微信扫码支付</div>
        <div class="flex ju-cn mb20">
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </el-dialog>
      <div ref="alipayWap"/>
    </el-row>
  </su-page>
</template>
<script>

import {
  address_list,
  agreement, check_status,
  getEduList,
  getExamTime,
  getForignList,
  getPthList,
  price_list,
  registerExam, subjectLists, submit
} from "@/api/api";

import {baseApi} from '@/utils/request.js'
import {mapState} from "vuex";
import QRCode from "qrcodejs2";

export default {
  name: "signUp",
  data() {
    return {
      // 购买课程定时器
      timer: null,
      checked: false,
      form: {
        name: '', // 姓名
        sex: '', //性别 0女，1男
        nation: '', // 民族
        cert_type: '', // 证件类型
        cert_no: '', // 证件号码
        picture: '', // 头像
        birthday: '', // 出生年月
        age: '', // 年龄
        type: '0', // 考试报名
        address_id: '', // 考试地点
        // subject: [], // 补考科目
        exam_subject: [], // 补考科目
        exam_time: '', // 考试时间
        education: '', // 学历
        school: '', // 毕业/就读院校
        personal: '', // 专业
        mandarin: '', // 普通话等级
        foreign: '', // 所学外语及程度
        is_teacher: '', // 国际中文相关证书
        pay_type: '', // 缴费方式
        address: '', // 通讯地址
        email: '', // Emall
        wx_account: '', // 微信号
        mobile: '', // 手机
        remark: '', // 备注
        man_cert: '', // 普通话证书图片
        teacher_cert: '', // 国际中文相关证书图片
        foreign_cert: '', // 外语证书图片
      },
      headers: [],
      // 考试科目
      subjectList: [],
      is_teacherList: [
        {
          id: 0,
          name: '无'
        }, {
          id: 1,
          name: '国际中文教师证书'
        }, {
          id: 2,
          name: '国际中文教育专业硕士学位证'
        }],
      picture: require('@/assets/image/avatar.jpg'),
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        sex: [
          {required: true, message: '请选择性别', trigger: 'blur'}
        ],
        nation: [
          {required: true, message: '请选择民族', trigger: 'blur'}
        ],

        cert_type: [
          {required: true, message: '请选择证件类型', trigger: 'blur'}
        ],
        cert_no: [
          {required: true, message: '请输入证件号码', trigger: 'blur'},
          //判断form.cert_type等于身份证还是护照，进行不同的正则验证
          {
            validator: (rule, value, callback) => {
              if (this.form.cert_type === '身份证') {
                // 身份证正则验证
                const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                if (idCardReg.test(value)) {
                  callback();
                } else {
                  callback(new Error('请输入正确的证件号码'));
                }
              } else {
                // 护照正则验证
                return new RegExp(/^[a-zA-Z0-9]{5,17}$/).test(value) ? callback() : callback(new Error('请输入正确的证件号码'))
              }
            }, trigger: 'blur'
          }
        ],
        picture: [
          {required: true, message: '请上传头像', trigger: 'blur'}
        ],
        birthday: [
          {required: true, message: '请选择出生年月', trigger: 'blur'}
        ],
        age: [
          {required: true, message: '请输入年龄', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择考试报名', trigger: 'blur'}
        ],
        address_id: [
          {required: true, message: '请选择考试地点', trigger: 'blur'}
        ],
        /*exam_time: [
          {required: true, message: '请选择考试时间', trigger: 'blur'}
        ],*/
        education: [
          {required: true, message: '请选择学历', trigger: 'blur'}
        ],
        school: [
          {required: true, message: '请选择毕业/就读院校', trigger: 'blur'}
        ],
        personal: [
          {required: true, message: '请选择专业', trigger: 'blur'}
        ],
        exam_subject: [
          {required: true, message: '请选择补考科目', trigger: 'blur'}
        ],
        mandarin: [
          {required: true, message: '请选择普通话等级', trigger: 'blur'}
        ],
        is_teacher: [
          {required: true, message: '请选择国际中文相关证书', trigger: 'blur'}
        ],
        foreign: [
          {required: true, message: '请选择外语及程度', trigger: 'blur'}
        ],
        pay_type: [
          {required: true, message: '请选择缴费方式', trigger: 'blur'}
        ],
        man_cert: [
          {required: true, message: '请上传普通话证书图片', trigger: 'blur'}
        ],
        foreign_cert: [
          {required: true, message: '请上传外语证书图片', trigger: 'blur'}
        ],
        teacher_cert: [
          {required: true, message: '请上传国际中文相关证书图片', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入通讯地址', trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入Emall', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
                callback(new Error('请输入正确的邮箱'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ],
        wx_account: [
          {required: true, message: '请输入微信号', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入手机', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ],
      },
      baseApi: baseApi + '/api/user/upload',
      agreementContent: '', // 协议内容
      dialogVisible: false, // 协议弹窗
      foreignList: [], // 外语列表
      pthList: [], // 普通话
      educationList: [], // 学历列表
      addressList: [], // 考点列表
      //给弹出框设置宽度，判断当前是移动端还是pc端
      dialogWidth: document.body.clientWidth < 750 ? '90%' : '60%',
      entryFee: {}, // 报名费
      tip: '', // 提示信息
      exam_fee: 0, //资料费

      buy_code: false, // 支付弹框
      text: "https://www.baidu.com/", //二维码内容
      qrUrl: "https://www.baidu.com/", // 支付二维码
      // 弹出购买二维码
      purchaseCode: false,
    }
  },
  computed: {
    ...mapState(['token', 'userInfo']),
    //费用总计
    total() {
      //fee1科目一价格,fee2科目二价格,fee3普通话考试价格,fee4英语考试价格
      let total = 0
      if (this.form.type == '1') {
        this.form.exam_subject.forEach(item => {
          this.subjectList.forEach(item2 => {
            if (item2.id == item) {
              total += item2.price
            }
          })
        })
      } else {
        if (this.entryFee.fee1) {
          total = this.entryFee.fee1 + this.entryFee.fee2
        }
        if (this.form.is_teacher) {
          total -= this.entryFee.fee1
        }
        if (this.form.mandarin == '二级乙等或以上均无') {
          total += this.entryFee.fee3
        }
        if (this.form.foreign == "以上均无") {
          total += this.entryFee.fee4
        }
        total += this.exam_fee
      }
      return total
    },
  },
  mounted() {

  },
  created() {
    if (this.token) {
      this.getExamTime()
      this.agreement() // 协议
      this.getForignList()  // 外语
      this.getPthList() // 平台等级
      this.getEduList() // 学历
      this.address_list() // 考点
      // this.price_list() // 报名费
      this.subjectLists() // 科目列表
    }
  },
  methods: {
    // 考点
    addressChange(e) {
      if (e) {
        const address = this.addressList.find(item => item.id == e);
        this.exam_fee = address.exam_fee ? Number(address.exam_fee) : 0;
      }
    },
    // 报名费
    price_list() {
      price_list().then(res => {
        if (res.status === 200) {
          res.data.fee1 = Number(res.data.fee1)
          res.data.fee2 = Number(res.data.fee2)
          res.data.fee3 = Number(res.data.fee3)
          res.data.fee4 = Number(res.data.fee4)
          this.entryFee = res.data
          this.tip = res.data.tip
        }
      })
    },
    // 科目列表
    subjectLists() {
      subjectLists().then(res => {
        if (res.status === 200) {
          let obg = {}
          res.data.forEach(item => {
            item.price = Number(item.price)
            if (item.tag == 'foreign') {
              obg.fee4 = item.price // 英语
            } else if (item.tag == 'mandarin') {
              obg.fee3 = item.price // 普通话
            } else if (item.tag == 'basic') {
              obg.fee2 = item.price // 科目二
            } else if (item.tag == 'major') {
              obg.fee1 = item.price // 科目一
            }
          })
          this.entryFee = obg
          this.subjectList = res.data
        }
      })
    },
    // 身份证和护照的判断
    certNoBlur(e) {
      if (this.form.cert_type == '身份证') {
        if (new RegExp(/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/).test(e)) {
          // 计算出年龄
          this.form.age = new Date().getFullYear() - new Date(e.substr(6, 4) + '-' + e.substr(10, 2) + '-' + e.substr(12, 2)).getFullYear()
          // 计算出 出生年月日
          this.form.birthday = e.substr(6, 4) + '-' + e.substr(10, 2) + '-' + e.substr(12, 2)
        }
      }
    },
    // 获取考试时间
    getExamTime() {
      getExamTime().then(res => {
        if (res.status === 200) {
          this.form.exam_time = res.data.date
        }
      })
    },
    // 获取考点列表
    address_list() {
      address_list().then(res => {
        if (res.status === 200) {
          this.addressList = res.data.list
        }
      })
    },
    // 获取学历列表
    getEduList() {
      getEduList().then(res => {
        if (res.status === 200) {
          this.educationList = res.data
        }
      })
    },
    //普通话水平
    getPthList() {
      getPthList().then(res => {
        if (res.status === 200) {
          this.pthList = res.data
        }
      })
    },
    // 获取外语列表
    getForignList() {
      getForignList().then(res => {
        if (res.status === 200) {
          this.foreignList = res.data
        }
      })
    },
    // 协议
    agreement() {
      agreement().then(res => {
        if (res.status === 200) {
          this.agreementContent = res.data.agreement
          this.tip = res.data.tip
        }
      })
    },
    // 提交表单
    submitForm(formName) {
      if (!this.checked) {
        this.$message.warning('请先阅读并同意考试报名协议')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          registerExam(this.form).then(res => {
            if (res.status === 200) {
              this.$message({
                message: '报名提交成功，正在调起支付……',
                type: 'success'
              });
              this.payTheFees(res.data)
            }
          }).catch(err => {

          })
        } else {
          this.$message.warning('请填写完整信息')
          return false;
        }
      });
    },
    // 缴费
    payTheFees(e) {
      submit({
        pay_type: this.form.pay_type == 0 ? 'wechat' : 'alipay',
        bao_id: e.id
      }).then(res => {
        if (res.status === 200) {
          if (this.form.pay_type == 0) { //微信
            this.buy(e.id, res.data)
          } else { //支付宝
            this.$refs.alipayWap.innerHTML = res.data.content // 将后台返回的html代码添加到ref="alipayWap"的元素中
            const form = this.$refs.alipayWap.querySelector('form')
            if (form) {
              form.submit() // 提交表单
            }
          }
        }
      })
    },
    // 购买
    async buy(id, e) {
      //弹出购买二维码
      this.buy_code = true
      this.timer = setInterval(() => {
        check_status({
          order_id: id
        }).then(res => {
          if (res.status === 200) {
            if (res.data.pay_status) {
              this.buy_code = false
              this.$message.success('购买成功')
              this.buy_close()
              // 购买成功后的相关操作
              this.$router.push({
                path: '/userCenter/myRegistration',
                query: {}
              });
              this.resetForm('formData')
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }, 2000)
      //使用nextTick确保在弹框显示前二维码数据渲染，不加的话可能报错获取不到qrcode元素
      this.$nextTick(() => {
        this.qrcode = new QRCode("qrcode", {
          width: 150,//二维码宽度
          height: 150,//二维码高度
          text: e.code_url,//调用微信支付接口返回的微信特殊链接：例如"weixin://wxpay/bizpayurl?pr=uDKsQ4E00"
          colorDark: "#000",//颜色配置
          colorLight: "#fff",
        });
      })
    },
    // 购买课程弹框关闭
    buy_close() {
      clearInterval(this.timer) // 清除定时器
      this.$refs.qrcode.innerHTML = "";//清空渲染的二维码
      this.timer = null // 清除定时器
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    },
    //头像
    pictureSuccess(res, file) {
      this.form.picture = res.data.url
      console.log(this.form.picture)
      // URL.createObjectURL(file.raw);
    },
    // 国际中文相关证书图片
    isTeacherSuccess(res, file) {
      this.form.teacher_cert = res.data.url
    },
    //普通话证书图片
    hmanCertSuccess(res, file) {
      this.form.man_cert = res.data.url
    },
    // 上传外语证书图片
    handleAvatarSuccess(res, file) {
      this.form.foreign_cert = res.data.url
    },
    // 图片上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      //上传头像图片大小不能超过 500k!
      const isLt500k = file.size / 1024 / 1024 < 0.5;
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('图片只能是 JPG 格式!');
      }
      if (!isLt500k) {
        this.$message.error('图片大小不能超过 500k!');
      }
      return isJPG && isLt500k;
    }
  },
}
</script>

<style lang="scss">
@media (min-width: 750px) {
  .signUp {
    grid-column-gap: 15px;
    display: grid;
    grid-template-columns:calc(50% - 7px)calc(50% - 7px);

    .uploadDescription {
      line-height: 18px;
      font-size: 15px;
    }

    .uploadDescription1 {
      //隐藏
      display: none;
    }
  }
}

@media (max-width: 750px) {
  .uploadDescription {
    display: none;
  }
  .uploadDescription1 {
    line-height: 16px;
    margin-bottom: 10px;
    font-size: 14px;
  }
}

.uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: -17px;
}

.uploader .el-upload:hover {
  border-color: #C32912;
}

.uploaderIcon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}

.uploaderImg {
  width: 130px;
  height: 130px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 90px;
  height: 124px;
  line-height: 124px;
  text-align: center;
}

.avatar {
  width: 90px;
  height: 124px;
  display: block;
}
</style>
